import React from 'react';

import place1 from './assets/place1.png';
import place2 from './assets/place2.png';
import place3 from './assets/place3.png';
import place4 from './assets/place4.png';

export default function FinishedTournamentWinner(props: {
  winners: { name: string | undefined; amt: string | undefined }[];
}) {
  const images = [place1, place2, place3, place4];
  return (
    <div className="finished-additional__winners">
      {props.winners.map((winner, index) => {
        return winner.name ? (
          <div className="finished-additional__winners-item" key={winner.name}>
            <div className="finished-additional__winners-img">
              <img className="" src={images[index]} alt="prize" />
            </div>
            <div className="finished-additional__winners-payer">
              <div className="finished-additional__winners-name">{winner.name}</div>
              <div className="finished-additional__winners-prize">{`${winner.amt} Tickets`}</div>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
}
